import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './DashboardLayout.css';

const DashboardLayout = ({ children, title }) => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getRoleDisplayName = (role) => {
    const roleMap = {
      super_admin: 'Super Admin',
      admin: 'Admin',
      operations: 'Operations',
      property_owner: 'Property Owner',
      client: 'Client',
      housekeeping: 'Housekeeping',
    };
    return roleMap[role] || role;
  };

  return (
    <div className="dashboard-layout">
      <nav className="dashboard-nav">
        <div className="nav-brand">
          <h2>MPMS</h2>
        </div>
        <div className="nav-user">
          <span>{user?.name} ({getRoleDisplayName(user?.role)})</span>
          <button onClick={handleLogout} className="btn btn-secondary btn-sm">
            Logout
          </button>
        </div>
      </nav>
      <div className="dashboard-content">
        {title && <h1 className="page-title">{title}</h1>}
        {children}
      </div>
    </div>
  );
};

export default DashboardLayout;

